import React, { Dispatch, SetStateAction } from 'react'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'

import { routes } from 'router/routes'
import theme from 'theme'
import {
  PORTFOLIO_EDIT_INVESTOR_PROFILE_BUTTON,
  PORTFOLIO_EDIT_STOCK_AND_ETFS_BANNER_BUTTON,
} from 'utils/testing/testIDs'

import { EditPortfolioDrawerOptions } from './constants'
import { EditPortfolioListItem } from './EditPortfolioListItem'
import {
  AddNewOptionOuterContainer,
  EditPortfolioListContainer,
  EditProfileContainer,
  EditProfileHeader,
  StarsIcon,
  StyledDrawer,
  StyledPageDivider,
  TierBadge,
  TierBadgeText,
} from './styled-components'

type Props = {
  isDrawerOpen: boolean
  setIsDrawerOpen: Dispatch<SetStateAction<boolean>>
  portfolioTheme: string
  portfolioRisk: string
  isCryptoInPortfolio: boolean
  isCustomPortfolio: boolean
}

const EditPortfolioDrawer = ({
  isDrawerOpen,
  setIsDrawerOpen,
  portfolioTheme,
  portfolioRisk,
  isCryptoInPortfolio,
  isCustomPortfolio,
}: Props) => {
  const { getRemoteString } = useRemoteStrings()
  const editPortfolioDrawerOptions = EditPortfolioDrawerOptions(
    getRemoteString,
    portfolioTheme,
    portfolioRisk,
    isCryptoInPortfolio,
    isCustomPortfolio,
  )
  return (
    <StyledDrawer
      isOpen={isDrawerOpen}
      title={getRemoteString({
        key: 'portfolio.edit.header',
      })}
      onClose={() => setIsDrawerOpen(false)}
    >
      <EditPortfolioListContainer>
        {editPortfolioDrawerOptions.map((option, index) => (
          <EditPortfolioListItem
            header={option.header}
            subHeader={option.subHeader}
            icon={option.icon}
            url={option.url}
            testId={option.testId}
            key={index}
          />
        ))}
      </EditPortfolioListContainer>
      {!isCustomPortfolio && (
        <AddNewOptionOuterContainer>
          <TierBadge>
            <StarsIcon icon={AcornsIcon.Icon.Stars} />
            <TierBadgeText>
              {getRemoteString({
                key: 'tier_selection.tier_name.platinum',
              })}
            </TierBadgeText>
          </TierBadge>
          <EditPortfolioListItem
            header={getRemoteString({
              key: 'portfolio.edit.securities.title',
            })}
            subHeader={getRemoteString({
              key: 'portfolio.edit.securities.subtitle',
            })}
            icon={AcornsIcon.Icon.UtilityPortfolio}
            url={routes.customPortfolio.lander}
            testId={PORTFOLIO_EDIT_STOCK_AND_ETFS_BANNER_BUTTON}
            color={theme.colors.darkOak}
          />
        </AddNewOptionOuterContainer>
      )}

      <StyledPageDivider thin={true} />
      <EditProfileContainer>
        <EditProfileHeader>
          {getRemoteString({
            key: 'portfolio.edit.profile.header',
          })}
        </EditProfileHeader>
        <EditPortfolioListItem
          header={getRemoteString({
            key: 'portfolio.edit.investor_profile.title',
          })}
          icon={AcornsIcon.Icon.UtilityProfile}
          url={routes.portfolio.investorProfile}
          testId={PORTFOLIO_EDIT_INVESTOR_PROFILE_BUTTON}
        />
      </EditProfileContainer>
    </StyledDrawer>
  )
}

export { EditPortfolioDrawer }
